import { EpicRefined } from 'interfaces/middleware'
import { merge, EMPTY, of } from 'rxjs'
import { combineEpics } from 'redux-observable'
import { map, mergeMap } from 'rxjs/operators'
import { PageFilterActions, SetFilterByAccountsAction, ToggleComparisonAction } from 'components/features/pageFilters/actions'
import { PATCH_MEMBER_PREFERENCES_URL } from 'interfaces/ajax'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { isEqual } from 'lodash'
import { filterRequest } from 'rxOperators/filterRequestOfType'


const patchToggleComparisonEpic: EpicRefined<PageFilterActions | AjaxCatchExtraActions> = (action$, store, { post }) => action$.pipe(
  filterRequest(ToggleComparisonAction.type),
  mergeMap((action) => {
    const state = store.getState()
    const { pageFilters } = state.app

    const { isEnabled } = action.payload.params

    if (isEnabled === pageFilters.comparison) {
      return EMPTY
    }

    return merge(
      of(action.success({
        isEnabled,
      })),
      post(PATCH_MEMBER_PREFERENCES_URL, {
        body: {
          filters: {
            are_comparisons_enabled: isEnabled,
          },
        },
      }).pipe(
        mergeMap(() => EMPTY),
        ajaxCatch(() => EMPTY),
      ),
    )
  }),
)

const patchFilterByAccountsEpic: EpicRefined<PageFilterActions | AjaxCatchExtraActions> = (action$, store, { post }) => action$.pipe(
  filterRequest(SetFilterByAccountsAction.type),
  mergeMap((action) => {
    const state = store.getState()
    const disabled_accounts = Object.keys(action.payload.params.uids).filter((key) => !action.payload.params.uids[key])

    if (isEqual(disabled_accounts, state.app.pageFilters.disabled_accounts)) {
      return EMPTY
    }

    return post(PATCH_MEMBER_PREFERENCES_URL, {
      body: {
        filters: {
          excluded_account_uids: disabled_accounts,
        },
      },
    }).pipe(
      map(() => action.success({
        disabled_accounts,
      })),
      ajaxCatch(() => EMPTY),
    )
  }),
)

export const pageFiltersEpics = combineEpics(
  patchToggleComparisonEpic,
  patchFilterByAccountsEpic,
)
